import { EqlFieldsAutoComplete } from '@modules/common/components/EqlFieldsAutoComplete';
import { EMPTY_EQL_FIELD_VALUE } from '@modules/common/components/EqlFieldsAutoComplete/constants';
import {
  LINK_METADATA_ACCOUNT_ID_FIELD_OPTION,
  LINK_METADATA_USER_ID_FIELD_OPTION,
} from '@modules/integrationsV2/constants';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { ArrowDropDownRounded } from '@mui/icons-material';
import {
  AutocompleteRenderInputParams,
  Box,
  InputAdornment,
  TextField,
} from '@mui/material';
import { EqlField, IntegrationType } from 'generated/graphql';
import { capitalize } from 'lodash';
import { SyntheticEvent } from 'react';

interface MetadataFieldAutoCompleteProps {
  integrationSource: IntegrationSource;
  onChange: (_: SyntheticEvent, eqlField: EqlField | null) => void;
  value: EqlField | undefined;
  isLinked: boolean;
  isDisabled?: boolean;
  isLoading?: boolean;
  eqlFields: EqlField[];
  isError: boolean;
}

export const MetadataFieldMappingAutoComplete = ({
  integrationSource,
  onChange,
  value,
  isLinked,
  isDisabled,
  isLoading,
  eqlFields,
  isError,
}: MetadataFieldAutoCompleteProps) => {
  const labelName = integrationSource.namespace
    ? `${integrationSource.channel.displayName} - ${integrationSource.namespace}`
    : integrationSource.channel.displayName;

  const optionsToDisplay = (() => {
    let options = eqlFields.filter((option) => {
      return (
        option.detail?.metadata?.source.toLowerCase() ===
          integrationSource.source?.toLowerCase() &&
        option.objectType.toString() ===
          integrationSource.integrationType.toString()
      );
    });

    if (integrationSource.integrationType === IntegrationType.User) {
      options = [LINK_METADATA_USER_ID_FIELD_OPTION, ...options];
    }

    if (integrationSource.integrationType === IntegrationType.Account) {
      options = [LINK_METADATA_ACCOUNT_ID_FIELD_OPTION, ...options];
    }

    return options;
  })();

  return (
    <Box width="17vw" minWidth="150px" maxWidth="350px">
      <EqlFieldsAutoComplete
        value={value ?? EMPTY_EQL_FIELD_VALUE}
        onChange={onChange}
        popupIcon={<ArrowDropDownRounded />}
        options={optionsToDisplay}
        getOptionLabel={(option) => option.displayName}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <TextField
            {...params}
            sx={{
              fieldset: {
                borderColor: isError
                  ? 'error.light'
                  : isLinked
                  ? 'success.light'
                  : undefined,
                borderWidth: isLinked || isError ? '1.5px' : undefined,
              },
            }}
            label={`${capitalize(
              integrationSource.integrationType,
            )}: ${labelName}`}
            placeholder={isLoading ? 'Loading...' : 'Select'}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position="start">
                  <Box
                    width="24px"
                    component="img"
                    alignSelf="center"
                    src={integrationSource.channel.logo}
                    alt={integrationSource.channel.displayName}
                  />
                </InputAdornment>
              ),
            }}
          />
        )}
        groupBy={() => ''}
        disabled={isDisabled || isLoading}
      />
    </Box>
  );
};
